import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { DynamicTooltipChip } from 'src/components/dynamicTooltipChip/DynamicTooltipChip';
import { useUserRole } from 'src/utils';

import { InputWrapper } from '../inputWidget/InputWidget.styled';
import { WidgetsCommonProps } from '../widget.interface';
import {
  getStyles,
  MenuProps,
  StyledBox,
  StyledFormControl,
} from './ChipInputWidget.styled';

export const ChipInputWidget = React.forwardRef(
  (props: WidgetsCommonProps, ref) => {
    const { value, error, hasError, label, disabled, onChange, selectOptions } =
      props;
    const theme = useTheme();
    const [labelName, setLabelName] = useState<string[]>(
      Array.isArray(selectOptions)
        ? selectOptions.map((item) => item.label)
        : [],
    );

    useEffect(() => {
      setLabelName(Array.isArray(value) ? value : []);
    }, [value]);

    const handleChange = (event: SelectChangeEvent<typeof labelName>) => {
      const {
        target: { value },
      } = event;
      const newValue = typeof value === 'string' ? value.split(',') : value;
      setLabelName(newValue);
      onChange(newValue);
    };

    const { isViewOnly } = useUserRole();

    return (
      <InputWrapper ref={ref}>
        <StyledFormControl
          $isViewOnly={isViewOnly}
          error={hasError}
          disabled={disabled}>
          <InputLabel id="chip-input-widget-label">{label}</InputLabel>
          <Select
            labelId="chip-input-widget-label"
            id="chip-input-widget"
            multiple
            value={labelName}
            onChange={handleChange}
            input={<OutlinedInput id="select-multiple-chip" label={label} />}
            renderValue={(selected) => (
              <StyledBox>
                {selected.map((value) => (
                  <DynamicTooltipChip key={value} chipName={value} />
                ))}
              </StyledBox>
            )}
            MenuProps={MenuProps}>
            {Array.isArray(selectOptions) &&
              selectOptions.map((item, index) => (
                <MenuItem
                  key={index}
                  value={item.label}
                  style={getStyles(item?.label, labelName, theme)}>
                  {item.label}
                </MenuItem>
              ))}
          </Select>
          {hasError && <div>{error}</div>}
        </StyledFormControl>
      </InputWrapper>
    );
  },
);
